import React, { useState } from 'react'
import Header from '../components/myComponents/Header'
import { AnimatedTooltipPreview } from '../components/aceternityUi/MenuIcons.tsx'
import { TracingBeamDemo } from '../components/aceternityUi/TraceBeam.tsx';
import SEO from '../components/myComponents/SEO.js';
import { Link } from 'react-router-dom';
import { HoverBorderGradient } from "../components/ui/hover-border-gradient.tsx";
import placeholderImg from "../assets/loading.png";
import Linkedin from "../assets/linkedin.png";
import email from "../assets/email.png";
import phone from "../assets/phone-call.png";
import Profile from "../assets/IMG_20220207_162513.png";
import Certificates from "../Data/CertificatesData.js"
// import Footer from '../components/myComponents/Footer.js'

function Resume() {
  const [loading, setLoading] = useState(true);

  const handleImageLoaded = () => {
    setLoading(false);
  }

  return (
    <>
      <SEO
        title="Resumé - Tshepo Maseeme"
        description="Take a look at a young South African software developer's career highlights, skills and expertise in the tech industry. "
        name="Tshepo Maseeme"
        type="article"
      />
      <Header/>
      <AnimatedTooltipPreview/>
      <TracingBeamDemo
        children={
        <section className="flex flex-col justify-center sm:px-6 md:px-24">
          <div className="h-64 grid grid-cols-8 p-4 w-full">
            <div className="col-start-1 col-span-3 flex w-full justify-end">
              <div className="my-auto h-52 w-52 overflow-hidden rounded-full">
                {loading && <img className="m-auto animate-spin max-h-[4rem]" src={placeholderImg} alt="loading"/>}
                <img className="w-full h-full object-cover" src={Profile} alt="Profile" onLoad={handleImageLoaded} />
              </div>
            </div>
            <div className="col-start-4 col-span-5 flex flex-col justify-between pl-6 ">
              <div className="h-[80%] flex align-center">
                  <ul className="flex flex-row place-content-evenly w-full h-fit m-auto font-bold place-content-evenly">
                    <li className="relative group">
                      <div className="absolute opacity-0 transition-opacity group-hover:opacity-100 child-element bottom-12 right-5 flex text-xs flex-col items-center justify-center rounded-md bg-gradient-to-br from-black to-gray-600 z-50 shadow-xl px-4 py-2">
                        <div className="absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-violet-700 to-transparent h-px " />
                        <div className="absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-cyan-300 to-transparent h-px " />
                        <div className="font-bold text-white relative z-30 text-base">Phone:</div>
                        <div className="text-white text-xs"><p className="w-full">+27662352544</p></div>
                      </div>
                      <Link to="tel: +27 66 235 2544" className="child-element "><img src={phone} alt="Phone" className='sm:w-6 sm:h-6 md:w-10 md:h-10'/></Link>
                    </li>
                      <li className="relative group">
                      <div className="absolute opacity-0 transition-opacity group-hover:opacity-100 child-element bottom-12 right-5 flex text-xs flex-col items-center justify-center rounded-md bg-gradient-to-br from-black to-gray-600 z-50 shadow-xl px-4 py-2">
                        <div className="absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-violet-700 to-transparent h-px " />
                        <div className="absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-cyan-300 to-transparent h-px " />
                        <div className="font-bold text-white relative z-30 text-base">LinkedIn:</div>
                        <div className="text-white text-xs"><p>Contact me</p></div>
                      </div>
                      <Link to="https://www.linkedin.com/in/tshepomaseemesean66235244" className=""><img src={Linkedin} alt="Linkedin" className='sm:w-6 sm:h-6 md:w-10 md:h-10'/></Link>
                    </li>
                    <li className="relative group">
                    <div className="absolute opacity-0 transition-opacity group-hover:opacity-100 child-element bottom-12 right-5 flex text-xs flex-col items-center justify-center rounded-md bg-gradient-to-br from-black to-gray-600 z-50 shadow-xl px-4 py-2">
                        <div className="absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-violet-700 to-transparent h-px " />
                        <div className="absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-cyan-300 to-transparent h-px " />
                        <div className="font-bold text-white relative z-30 text-base">Email:</div>
                        <div className="text-white text-xs"><p>maseemet0@gmail.com</p></div>
                      </div>
                    <Link to="mailto:maseemet0@gmail.com" className=""><img src={email} alt="Linkedin" className='w-6 h-6 md:w-10 md:h-10'/></Link>
                    </li>
                  </ul>
              </div>
              <Link to="https://drive.google.com/file/d/1gxOvPgEn18hUu6GGTnIBKI1XNGyl_hSE/view?usp=drive_link" target="_blank" className='justify-self-end justify-center flex mb-auto'>
                <HoverBorderGradient>
                  <button className="w-full font-bold text-center rounded-xl">Download CV</button>
                </HoverBorderGradient>
              </Link>
            </div>
          </div>

          {/* Experience section */}
          <h1 className='font-bold text-xl justify-self-start flex'>Experience</h1>
          <div className='grid grid-cols-8 p-4 h-fit w-full'>

            <div className='col-start-1 col-span-3 h-fit text-right pr-3'>
              <p className="md:text-base sm:text-sm">15 Feb 2024 - 15 Mar 2024</p>
            </div>
            <div className='col-start-4 col-span-5 md:text-base sm:text-sm pl-6 border-l-2 border-black h-full text-left'>
              <ul>
                  <li>Internship at <Link to="https://zidio.in/" target="_blank" className='hover:text-violet-700'>Zidio Development ↗.</Link></li>
                  <li>One month collaboration with 5 team members.</li>
                  <li>While working on a web project I did the UI/UX design and developed the frontend interface</li>
                  <li>I gained time management and collaboration skills</li>
              </ul>
            </div>

            <div className='col-start-1 col-span-3 h-fit text-right pr-3'>
              <p className="md:text-base sm:text-sm">1 Sep 2024 - 18 Dec 2024</p>
            </div>
            <div className='col-start-4 col-span-5 md:text-base sm:text-sm pl-6 border-l-2 border-black h-full text-left'>
              <ul>
                  <li>Internship at <Link to="https://www.vaimo.com" target="_blank" className='hover:text-violet-700'>Vaimo ↗.</Link></li>
                  <li>Worked with JavaScript frameworks such as Knockout.js and RequireJS for Magento customization.</li>
                  <li>Designed and implemented user interfaces using LESS and custom CSS.</li>
                  <li>Participated in collaborative coding sessions and workflow discussions.</li>
                  <li>Shadowed expert developers to gain insight into real-world Magento project workflows.</li>
              </ul>
            </div>
          </div>

          {/* Education section */}
          <h1 className='font-bold text-xl flex justify-self-start'>Education</h1>
          <div className='grid grid-cols-8 py-4 h-fit w-full'>

            <div className='col-start-1 col-span-3 h-fit text-right pr-3'>
              <p className="md:text-base sm:text-sm">2022-2025</p>
            </div>
            <div className='col-start-4 md:text-base sm:text-sm pl-6 col-span-5 h-fit border-l-2 border-black text-left'>
              <ul>
                  <li>I completed a Diploma in Information Technology at Belgium Campus iTversity, a private higher education institution registered with South Africa’s Department of Higher Education and Training. My studies ran from 2022 to 2025, and I fulfilled all academic requirements for the qualification, achieving the full 360 credits with a weighted average of 74.7%.</li>
              </ul>
            </div>
          </div>

          {/* Awards section */}
          <h1 className='font-bold text-xl flex justify-self-start'>Certifications</h1>

            {Certificates.map((award, index) => (
                      <div key={index} className='parent group grid grid-cols-8 place-content-center py-1 h-fit w-full'>
                          <div className='col-start-1 group-hover:text-violet-700 md:text-base sm:text-sm col-span-3 h-fit text-right pr-3'>
                              <p>{award.date}</p>
                          </div>
                          <div className='col-start-4 md:text-base sm:text-sm pl-6 col-span-5 h-fit border-l-2 border-black text-left'>
                          <Link to={award.link} target="_blank" className='group-hover:text-violet-700'><p>{award.name} ↗</p></Link>
                          </div>
                      </div>
            ))}
      </section>}
      />
    </>
  )
}

export default Resume